import React from 'react';
import { Redirect } from 'react-router-dom';
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';

import { getTeamData, sortCustomers } from '../../helpers';
import Navbar from '../Navbar/NavBar';
import CustomersMain from './CustomersMain';
import PAContainer from '../Shared/PracticeAreas/PAContainer';
import { useRouter } from '../../helpers/customHooks';
import { useFiltersState } from '../../store/hooks';
import { ShortTeamsData, TabConfig } from './types';
import { FILTER_GLOBAL_KEYS, LEAGUES } from '../../config/constants';
import AlertingMain from 'components/Alerting/AlertingMain';
import CustomersUsers from './CustomersUsers';
import CustomersSidebar from './CustomersSidebar';
import CustomersRoles from './CustomersRoles';

const TABS: TabConfig[] = [
  { key: 'users',    title: 'Users',          component: CustomersUsers },
  { key: 'roles',    title: 'Roles',          component: CustomersRoles },
  { key: 'players',  title: 'Players',        component: CustomersMain },
  { key: 'alerting', title: 'Live Alerting',  component: AlertingMain },
  { key: 'areas',    title: 'Practice Areas', component: PAContainer },
];

const NON_TEAM_TAB_KEYS = new Set(TABS.filter(t => t.key === 'roles').map(t => t.key));

export default () => {
  
  const { history, params } = useRouter<{ params: { teamId: string, tab: string } }>();
  const { teamId, tab } = params;
  const {
    [FILTER_GLOBAL_KEYS.VENUES]: venues = {
      nfl: { practice: [] },
      ncaaFbs: { practice: [] },
      mlax: { practice: [] }
    }
  } = useFiltersState('_', FILTER_GLOBAL_KEYS.VENUES);

  const venuesList = [...venues.nfl.practice, ...venues?.ncaaFbs.practice, ...venues.mlax.practice];
  const NflTeamsData: Array<ShortTeamsData> = [];
  const OsuTeamsData: Array<ShortTeamsData> = [];
  const ZebraTeamsData: Array<ShortTeamsData> = [];
  const filterVenues = venuesList.filter((venue)=> (venue.siteName !== 'toro' && venue.siteName !== 'badgerspractice' && venue.siteName !== 'hurricanespractice' && venue.siteCityAbbr !== 'TENN'));
  filterVenues.forEach((venue) => {
    if (venue.teamId !== '4500') {
      const teamData = getTeamData(venue.teamId as string) || {
        teamAbbrName: 'CC',
        teamNick: venue.siteName,
        teamId: venue.teamId,
        league: venue.league
      };
      if(teamData.league === LEAGUES.NFL){
          if(teamData.teamNick !== 'Zebra Team'){
            if (!NflTeamsData.some((team) => team!.teamId === teamData.teamId)) {
              NflTeamsData.push(teamData);
            }
          }else{
            if (!ZebraTeamsData.some((team) => team!.teamId === teamData.teamId)) {
              ZebraTeamsData.push(teamData);
            }
          }
      }
      if(teamData.league === LEAGUES.NCAA || teamData.league === LEAGUES.MLAX){
          if (!OsuTeamsData.some((team) => team!.teamId === teamData.teamId)) {
            OsuTeamsData.push(teamData);
          }
      }
      if(!teamData.league){
        if (!ZebraTeamsData.some((team) => team!.teamId === teamData.teamId)) {
          ZebraTeamsData.push(teamData);
        }
      }
    }
  });
  NflTeamsData.sort(sortCustomers('teamAbbrName'));
  OsuTeamsData.sort(sortCustomers('teamAbbrName'));
  ZebraTeamsData.sort(sortCustomers('teamAbbrName'));
  const teamsData = NflTeamsData.concat(OsuTeamsData,ZebraTeamsData);

  // /customers/roles → teamId='roles', tab=undefined — detect and resolve
  const isNonTeamUrl = NON_TEAM_TAB_KEYS.has(teamId) && !tab;
  const resolvedTab = isNonTeamUrl ? teamId : (tab ?? 'players');
  const resolvedTeamId = isNonTeamUrl ? undefined : teamId;

  if (!resolvedTeamId && !isNonTeamUrl && teamsData.length > 0) {
    return <Redirect to={`/customers/${teamsData[0].teamId}/${resolvedTab}`} />;
  }

  const activeTab = TABS.find(t => t.key === resolvedTab) ?? TABS[0];

  return (
    <>
      <Navbar />
      <Container className="container-00">
        <h4 className="h-t">Customers</h4>
        <Tabs
          defaultActiveKey="players"
          id="uncontrolled-tab-exampleX"
          mountOnEnter
          unmountOnExit
          activeKey={resolvedTab}
          onSelect={(e: string | null) => {
            const selected = TABS.find(t => t.key === e);
            if (selected?.key === "roles") {
              history.push(`/customers/${e}`);
            } else {
              const isValidTeamId = teamsData.some(t => String(t.teamId) === String(resolvedTeamId));
              const targetTeamId = isValidTeamId ? resolvedTeamId : teamsData[0]?.teamId;
              history.push(`/customers/${targetTeamId}/${e}`);
            }
          }}
        >
          {/*ALERTING CC ONLY! */}
          {TABS.map(({ key, title }) => (
            <Tab key={key} eventKey={key} title={title} />
          ))}
        </Tabs>
        <Row>
          <Col lg={12} xs={12}>
            <div className="customer">
              {activeTab.key !== "roles" ? (
                <Tab.Container id="left-tabs-example" activeKey={resolvedTeamId} mountOnEnter unmountOnExit>
                  <Row>
                    {activeTab.key === "users" ? (
                      <activeTab.component teamsData={teamsData} activeId={resolvedTeamId} />
                    ) : (
                      <>
                        <Col sm={3}>
                          <CustomersSidebar items={teamsData} activeId={resolvedTeamId} tab={resolvedTab}
                          />
                        </Col>
                        <activeTab.component teamsData={teamsData} />
                      </>
                    )}
                  </Row>
                </Tab.Container>
              ) : (
                <Row>
                  <Col sm={12}>
                    <activeTab.component teamsData={teamsData} />
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};